import { SharedConfig } from '../../../common/model/config';

export const stagingSharedConfig: SharedConfig = {
  timeout: 30000,
  defaultBrand: 4,
  sentryDSN: 'https://93e9708aa2d443839ccdf32505dabee9@sentry.monitor.onyo.com/31',
};
